<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="MBA"
                   :links="[{title:'Home', url:'/'},{title:'Academics Achievers'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="7"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Academic Achievers</div>
          <tab-view class="">
            <tab-panel header="2019-20">
              <div class="mb-4">
                <div class="heading-black1">MBA-I</div>
                <div class="mb-4">
                  <div class="grid grid-cols-3 gap-5">
                    <achiever-component
                        v-for="(users,index) in getResult('MBA-I','2019-20')"
                        :key="index"
                        :achiever="users">
                    </achiever-component>
                  </div>
                </div>
                <div class="heading-black1">MBA-II</div>
                <div class="grid grid-cols-3 gap-5">
                  <achiever-component
                      v-for="(users,index) in getResult('MBA-II','2019-20')"
                      :key="index"
                      :achiever="users">
                  </achiever-component>
                </div>
              </div>
            </tab-panel>
            <tab-panel header="2018-19">
              <div class="mb-4">
                <div class="heading-black1">MBA-I</div>
                <div class="mb-4">
                  <div class="grid grid-cols-3 gap-5">
                    <achiever-component
                        v-for="(users,index) in getResult('MBA-I','2018-19')"
                        :key="index"
                        :achiever="users">
                    </achiever-component>
                  </div>
                </div>
                <div class="heading-black1">MBA-II</div>
                <div class="grid grid-cols-3 gap-5">
                  <achiever-component
                      v-for="(users,index) in getResult('MBA-II','2018-19')"
                      :key="index"
                      :achiever="users">
                  </achiever-component>
                </div>
              </div>
            </tab-panel>
            <tab-panel header="2017-18">
              <div class="mb-4">
                <div class="heading-black1">MBA-I</div>
                <div class="mb-4">
                  <div class="grid grid-cols-3 gap-5">
                    <achiever-component
                        v-for="(users,index) in getResult('MBA-I','2017-18')"
                        :key="index"
                        :achiever="users">
                    </achiever-component>
                  </div>
                </div>
                <div class="heading-black1">MBA-II</div>
                <div class="grid grid-cols-3 gap-5">
                  <achiever-component
                      v-for="(users,index) in getResult('MBA-II','2017-18')"
                      :key="index"
                      :achiever="users">
                  </achiever-component>
                </div>
              </div>
            </tab-panel>
            <tab-panel header="2016-17">
              <div class="mb-4">
                <div class="heading-black1">MBA-I</div>
                <div class="mb-4">
                  <div class="grid grid-cols-3 gap-5">
                    <achiever-component
                        v-for="(users,index) in getResult('MBA-I','2016-17')"
                        :key="index"
                        :achiever="users">
                    </achiever-component>
                  </div>
                </div>
                <div class="heading-black1">MBA-II</div>
                <div class="grid grid-cols-3 gap-5">
                  <achiever-component
                      v-for="(users,index) in getResult('MBA-II','2016-17')"
                      :key="index"
                      :achiever="users">
                  </achiever-component>
                </div>
              </div>
            </tab-panel>
            <tab-panel header="2015-16">
              <div class="mb-4">
                <div class="heading-black1">MBA-I</div>
                <div class="mb-4">
                  <div class="grid grid-cols-3 gap-5">
                    <achiever-component
                        v-for="(users,index) in getResult('MBA-I','2015-16')"
                        :key="index"
                        :achiever="users">
                    </achiever-component>
                  </div>
                </div>
                <div class="heading-black1">MBA-II</div>
                <div class="grid grid-cols-3 gap-5">
                  <achiever-component
                      v-for="(users,index) in getResult('MBA-II','2015-16')"
                      :key="index"
                      :achiever="users">
                  </achiever-component>
                </div>
              </div>
            </tab-panel>
            <tab-panel header="2014-15">
              <div class="mb-4">
                <div class="heading-black1">MBA-I</div>
                <div class="mb-4">
                  <div class="grid grid-cols-3 gap-5">
                    <achiever-component
                        v-for="(users,index) in getResult('MBA-I','2014-15')"
                        :key="index"
                        :achiever="users">
                    </achiever-component>
                  </div>
                </div>
                <div class="heading-black1">MBA-II</div>
                <div class="grid grid-cols-3 gap-5">
                  <achiever-component
                      v-for="(users,index) in getResult('MBA-II','2014-15')"
                      :key="index"
                      :achiever="users">
                  </achiever-component>
                </div>
              </div>
            </tab-panel>
          </tab-view>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/mba/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import AchieverComponent from "@/components/AchieverComponent";

export default {
  name: "AcademicAchievers",

  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    TabView,
    TabPanel,
    AchieverComponent
  },
  data() {
    return {
      results: [
        {
          year: '2019-20',
          class: 'MBA-I',
          students: [
            {
              name: 'Thok Sonali Sanjay',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: 'SGPA-8.93'
            },
            {
              name: 'Malkar Harshada Sandip',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: 'SGPA-8.77'
            },
            {
              name: 'Aher Rucha Sunil',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: 'SGPA-8.87'
            }
          ]
        },
        {
          year: '2019-20',
          class: 'MBA-II',
          students: [
            {
              name: 'Jain Kapil Kishor',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '73.40 %'
            },
            {
              name: 'Pawar Avinash Uttam',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '73.36 %'
            },
            {
              name: 'Pawtekar Deepashri C.',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '73.10 %'
            }
          ]
        },
        {
          year: '2018-19',
          class: 'MBA-I',
          students: [
            {
              name: 'Pawar Avinash Uttam',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '70.81 %'
            },
            {
              name: 'Jain Kapil Kishor',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '69.06 %'
            },
            {
              name: 'Pawtekar Deepashri C.',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '68.31 %'
            }
          ]
        },
        {
          year: '2018-19',
          class: 'MBA-II',
          students: [
            {
              name: 'Bakle Ram Kailas',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '73.40 %'
            },
            {
              name: 'Gawali Prerana Kantilal',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '73.36 %'
            },
            {
              name: 'Kotame Anil Devnath',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '73.10 %'
            }
          ]
        },
        {
          year: '2017-18',
          class: 'MBA-I',
          students: [
            {
              name: 'Gawali Prerana Kantilal ',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '72.52%'
            },
            {
              name: 'Kotame Anil Devnath',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '71.52%'
            },
            {
              name: 'Unde Sonali Ashok ',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '69.17%'
            }
          ]
        },
        {
          year: '2017-18',
          class: 'MBA-II',
          students: [
            {
              name: 'Devade Shashikant Tanaji',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '71.17%'
            },
            {
              name: 'Chaukhande Pooja Dilip',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '70.13%'
            },
            {
              name: 'Shingare Nikita Vinod ',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '69.33%'
            }
          ]
        },
        {
          year: '2016-17',
          class: 'MBA-I',
          students: [
            {
              name: 'Devade Shashikant Tanaji',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '70.37 %'
            },
            {
              name: 'Chaukhande Pooja Dilip',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '67.31 %'
            },
            {
              name: 'Gunjal Harish Karbhari',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '66.00 %'
            }
          ]
        },
        {
          year: '2016-17',
          class: 'MBA-II',
          students: [
            {
              name: 'Labhade Amol Vasant',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '70.20%'
            },
            {
              name: ' Labhade Rekha Sopan',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '69.80%'
            },
            {
              name: 'Teke Sonali Balasaheb',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '69.63%'
            }
          ]
        },
        {
          year: '2015-16',
          class: 'MBA-I',
          students: [
            {
              name: 'Labhade Rekha Sopan',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: 'SGPA-8.50'
            },
            {
              name: 'Teke Sonali Balasaheb',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: 'SGPA-8.38'
            },
            {
              name: 'Labhade Amol Vasant',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: 'SGPA-8.32'
            }
          ]
        },
        {
          year: '2015-16',
          class: 'MBA-II',
          students: [
            {
              name: 'Borade Geeta Suryabhan',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '70.30%'
            },
            {
              name: 'Kabra Pooja Sudhakar',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '69.03%'
            },
            {
              name: 'Kotame Jayvanta Devnath',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '68.97%'
            }
          ]
        },
        {
          year: '2014-15',
          class: 'MBA-I',
          students: [
            {
              name: 'Borade Geeta Suryabhan',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '68.87%'
            },
            {
              name: 'Kabra Pooja Sudhakar',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '67.56%'
            },
            {
              name: 'Wavadhane Rupesh Ram',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '65.31%'
            }
          ]
        },
        {
          year: '2014-15',
          class: 'MBA-II',
          students: [
            {
              name: 'Shelke Bipin Balasaheb',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '67.40%'
            },
            {
              name: 'Shedge Sonali Vilas',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '67.10%'
            },
            {
              name: 'Borde Nivrutti Kacharu',
              image: '/static/images/mba/academicAchievers/2019-20/placeholder-150x150.jpg',
              score: '66.80%'
            }
          ]
        },
      ]
    }
  },
  methods: {
    getResult(className, year) {

      const s = this.results.filter(item => {
        return item.class === className && item.year === year
      });

      const result = JSON.parse(JSON.stringify(s))
      // console.log(result[0].students)
      return result[0].students;
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
